export { CONTACTS_PATH } from './constants'
export * from './containers'

export { BankContactsWrapper } from './BankContactsWrapper'
export * from './contactsRoutes'
